import { ApiClient } from "#/shared/api/client";
import { MenuConfig } from "#ce/apps/SpAiGeneratorQuillApp/models/menu-config";

class MenuConfigApi extends ApiClient {
  constructor() {
    super({ model: MenuConfig });
  }
}

export function createMenuConfigApi() {
  const api = new MenuConfigApi();

  return {
    fetch: (path) => api.get(path),
  };
}
